import evnConfig from '../config';
import {
    LoginStorage,
} from '@arredo/reactjs-ui';

const MapConfig = (method, body, config) => ({
    ...config,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'api-version': '1',
        'x-token': LoginStorage.token(),
        ...config?.headers
    },
    method,
    body
});

const _fetch = async (path, config) =>
    await fetch(`${evnConfig.apiGateway.URL}${path}`, config)
        .then(async res => {
            if (res.status === 401) {
                LoginStorage.clear();
                throw new Error("Not Authenticated")
            }

            if (res.status === 403) {
                if (window.location.pathname.startsWith('/unauthorized'))
                    return;

                const err = await res.json();
                const rawErr = err?.message ?? err?.Message ?? '';
                const message = rawErr.split(':');
                let url = '/unauthorized/';

                url += (message.length > 1) ? message[1].trim() : rawErr;
                window.location.replace(url);
            }

            if (res.status === 423)
                throw await res.json();

            if (res.status === 400 || !res.ok) {
                const data = await res.json();
                const raw = data?.Message ?? data?.message ?? data?.Title ?? 'Error call server';
                const temp = raw.split(':');
                const message = temp.length > 1 ? temp[1].split(',') : temp;
                const error = new Error(message[0]);
                error.name = data?.Error;
                throw error;
            }

            if (res.status === 204)
                return res;

            return res.json();
        });

const _fetchText = async (path, config) =>
    await fetch(`${evnConfig.apiGateway.URL}${path}`, config)
        .then(res => {
            if (res.status === 401) {
                LoginStorage.clear();
                throw new Error("Not Authenticated")
            }

            if (!res.ok)
                throw new Error(res.text() || 'Error call server');

            if (res.status === 204)
                return res;

            return res.text();
        });

const _fetchBlob = async (path, config) =>
    await fetch(`${evnConfig.apiGateway.URL}${path}`, config)
        .then(res => {
            if (res.status === 401) {
                LoginStorage.clear();
                throw new Error("Not Authenticated")
            }

            if (!res.ok)
                throw new Error(res.text() || 'Error call server');

            if (res.status === 204)
                return res;

            return res.blob();
        });

export class HttpClient {
    static Get = async (path, config) =>
        await _fetch(path, MapConfig('GET', null, config));

    static Post = async (path, data, config) =>
        await _fetch(path, MapConfig('POST', JSON.stringify(data), config));

    static Put = async (path, data, config) =>
        await _fetch(path, MapConfig('PUT', JSON.stringify(data), config));

    static Delete = async (path, data, config) =>
        await _fetch(path, MapConfig('DELETE', data ? JSON.stringify(data) : null, config));

    static Patch = async (path, data, config) =>
        await _fetch(path, MapConfig('PATCH', JSON.stringify(data), config))

    static Upload = async (path, file) => {
        const formData = new FormData();
        formData.append("file", file);

        return await _fetchText(path, {
            method: 'POST',
            headers: {
                'api-version': '1',
                'x-token': LoginStorage.token()
            },
            body: formData
        });
    }

    static GetText = async (path, config) =>
        await _fetchText(path, MapConfig('GET', null, config));

    static GetTextWithBody = async (path, data, config) =>
        await _fetchText(path, MapConfig('POST', JSON.stringify(data), config));

    static GetFile = async (path, config) =>
        await _fetchBlob(path, MapConfig('GET', null, config));

    static PostFile = async (path, data, config) =>
        await _fetchBlob(path, MapConfig('POST', data ? JSON.stringify(data) : null, config));
}

/**
 * Serializa un objeto para usarlo como url query
 * @param {object} obj Objeto a serializar
 */
export const SerializeAsQueryString = (obj) => {
    const str = [];
    for (const p in obj)
        if (obj.hasOwnProperty(p))
            if (obj[p] && obj[p] !== '')
                str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    return str.join('&');
}